// src/routes/PublicRoute.tsx

import React from "react";
import { useAuth } from "../context/AuthContext";

interface PublicRouteProps {
  element: JSX.Element;
}

const PublicRoute: React.FC<PublicRouteProps> = ({ element }) => {
  const { isAuthenticated } = useAuth();

  // ✅ Allow access to public routes regardless of auth status
  return element;
};

export default PublicRoute;